var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { components, tabs } from "./collection-action-area/";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { MENU_CHANNEL } from "~/config/enum.config";
import { RepairCasesService } from "~/services/domain-service/repair-cases.service";
var CollectionExecutionModule = namespace('collection-execution');
import { Prop } from "vue-property-decorator";
var CollectionActionArea = /** @class */ (function (_super) {
    __extends(CollectionActionArea, _super);
    function CollectionActionArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.collectionType = "";
        return _this;
    }
    Object.defineProperty(CollectionActionArea.prototype, "initComponent", {
        /**
         * 获取要展示的行动面板
         */
        get: function () {
            var _this = this;
            if (this.menuChannel === MENU_CHANNEL.Letter_repair_case) {
                this.getCaseCollectionType();
                return this.collectionType === "TEL"
                    ? tabs.find(function (v) { return v.channel.includes(MENU_CHANNEL.Tel_personal); }) || {}
                    : tabs.find(function (v) { return v.channel.includes(MENU_CHANNEL.Visit_personal); }) || {};
            }
            var tab = tabs.find(function (v) { return v.channel.includes(_this.menuChannel); }) || {};
            return tab;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 成功后更新历史纪录面板
     */
    CollectionActionArea.prototype.onFollowSuccess = function () {
        var _this = this;
        this.updateHistoryInfoActive("");
        this.updateAddRecordFlag(true);
        this.$nextTick(function () {
            _this.updateHistoryInfoActive(_this.initComponent.historyPanel);
        });
    };
    CollectionActionArea.prototype.getCaseCollectionType = function () {
        var _this = this;
        this.repairCasesService
            .getCollectionTypeByCaseId(this.caseId)
            .subscribe(function (data) { return (_this.collectionType = data); });
    };
    __decorate([
        Dependencies(RepairCasesService)
    ], CollectionActionArea.prototype, "repairCasesService", void 0);
    __decorate([
        CollectionExecutionModule.Getter
    ], CollectionActionArea.prototype, "collectonData", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], CollectionActionArea.prototype, "updateHistoryInfoActive", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], CollectionActionArea.prototype, "updateAddRecordFlag", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionActionArea.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CollectionActionArea.prototype, "menuChannel", void 0);
    __decorate([
        Prop()
    ], CollectionActionArea.prototype, "topInfo", void 0);
    CollectionActionArea = __decorate([
        Component({
            components: __assign({}, components)
        })
    ], CollectionActionArea);
    return CollectionActionArea;
}(Vue));
export default CollectionActionArea;
